import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import config from '../../config'
import * as Api from '../../common/Api';
import {LIST_STATUSES} from "../../common/metadata/ListStatuses";

const initialState = {
    loading: false,
    reload: false,
    alertMessage: undefined,
    successMessage: undefined,
    adminList: null,
};


const LIST_ACTION_URL_BASE = `${config.services.ATLAS.apiUrl}/managed-lists`;

export const getAdminListById = createAsyncThunk('adminLists/get-by-id', async (id) => {
    const URL = `${config.services.ATLAS.apiUrl}/managed-lists/${id}`;
    const adminList = await Api.get(true, URL);
    return adminList;
});

export const getAdminListWithFilter = createAsyncThunk('adminLists/get-by-id-with-filter', async ({id, filter}) => {
    const URL = `${config.services.ATLAS.apiUrl}/managed-lists/${id}`;
    const adminList = await Api.get(true, URL, filter);
    return adminList;
});


export const processList = createAsyncThunk('adminLists/process',
    async (id) => {
        const PROCESS_LIST = `${LIST_ACTION_URL_BASE}/${id}/process`;
        return await Api.post(true,
            PROCESS_LIST,
            {
                options: {
                    processToStatus: LIST_STATUSES.READY.id,
                }
            }
        );
    });

export const syncList = createAsyncThunk('adminLists/sync',
    async (id) => {
        const SYNC_LIST = `${LIST_ACTION_URL_BASE}/${id}/sync`;
        return await Api.post(true,
            SYNC_LIST,
            {
                options: {
                    processToStatus: LIST_STATUSES.READY.id,
                }
            }
        );
    });

export const reSyncList = createAsyncThunk('adminLists/re-sync',
    async (id) => {
        const SYNC_LIST = `${LIST_ACTION_URL_BASE}/${id}/re-sync`;
        return await Api.post(true,
            SYNC_LIST,
            {
                options: {
                    processToStatus: LIST_STATUSES.READY.id,
                }
            }
        );
    });

export const downloadList = createAsyncThunk('adminLists/download',
    async ({id, fileName}) => {
        const DOWNLOAD_LIST = `${LIST_ACTION_URL_BASE}/${id}/download`;
        return await Api.post(true,
            DOWNLOAD_LIST,
            {
                options: {
                },
                data: {
                    fileName: fileName
                }
            }
        );
    });
export const normalizeList = createAsyncThunk('adminLists/normalize',
    async (id) => {
        const NORMALIZE_LIST = `${LIST_ACTION_URL_BASE}/${id}/normalize`;
        return await Api.post(true,
            NORMALIZE_LIST,
            {
                options: {
                    processToStatus: LIST_STATUSES.NORMALIZED.id
                }
            }
        );
    });


export const parseList = createAsyncThunk('adminLists/parse',
    async (id) => {
        const NORMALIZE_LIST = `${LIST_ACTION_URL_BASE}/${id}/process`;
        return await Api.post(true,
            NORMALIZE_LIST,
            {
                options: {
                    processToStatus: LIST_STATUSES.PARSED.id
                }
            }
        );
    });

export const matchList = createAsyncThunk('adminLists/match',
    async ({id, matchTemplateId}) => {
        const URL = `${LIST_ACTION_URL_BASE}/${id}/match`;
        return await Api.post(true,
            URL,
            {
                options: null,
                data: {
                    matchTemplateId: matchTemplateId
                }
            }
        );
    });

const adminListSlice = createSlice({
    name: 'adminListSlice', initialState,
    reducers: {
        clearState: (state) => {
            state.loading = false;
            state.reload = false;
            state.alertMessage = undefined;
            state.successMessage = undefined;
            state.adminList = null;
            return state;
        },
        resetCreateOrganizationState: {
            reducer(state, action) {
                state.loading = false;
                state.reset = true;
                state.alertMessage = undefined;
                state.successMessage = undefined;
            }
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAdminListById.pending, (state, action) => {
                state.loading = true;
            })
            .addCase(getAdminListById.fulfilled, (state, action) => {
                state.loading = false;
                if (action.payload) {
                    state.adminList = action.payload;
                }
            })
            .addCase(getAdminListById.rejected, (state, action) => {
                state.loading = false;
                state.alertMessage = 'Unable to retrieve managed list';
            })
            .addCase(getAdminListWithFilter.pending, (state, action) => {
                state.loading = true;
                state.successMessage = undefined;
                state.alertMessage = undefined;
            })
            .addCase(getAdminListWithFilter.fulfilled, (state, action) => {
                state.loading = false;
                if (action.payload) {
                    state.adminList = action.payload;
                }
            })
            .addCase(getAdminListWithFilter.rejected, (state, action) => {
                state.loading = false;
                state.alertMessage = 'Unable to retrieve managed list';
            })
            .addCase(processList.pending, (state, action) => {
                state.loading = true;
                state.alertMessage = undefined;
                state.successMessage = undefined;
            })
            .addCase(processList.fulfilled, (state, action) => {
                state.alertMessage = undefined;
                state.successMessage = 'Successfully process list';
                state.loading = false;
            })
            .addCase(processList.rejected, (state, action) => {
                state.loading = false;
                state.alertMessage = 'Unable to process list';
                state.successMessage = undefined;
            })
            .addCase(normalizeList.pending, (state, action) => {
                state.loading = true;
                state.alertMessage = undefined;
                state.successMessage = undefined;
            })
            .addCase(normalizeList.fulfilled, (state, action) => {
                state.alertMessage = undefined;
                state.successMessage = 'Successfully normalize list';
                state.loading = false;
                if (action.payload) {
                    state.adminLists = action.payload;
                }
            })
            .addCase(normalizeList.rejected, (state, action) => {
                state.loading = false;
                state.alertMessage = 'Unable to normalize list';
                state.successMessage = undefined;
            })
            .addCase(syncList.pending, (state, action) => {
                state.loading = true;
                state.alertMessage = undefined;
                state.successMessage = undefined;
            })
            .addCase(syncList.fulfilled, (state, action) => {
                state.alertMessage = undefined;
                state.successMessage = 'Successfully sync list';
                state.loading = false;
                if (action.payload) {
                    state.adminLists = action.payload;
                }
            })
            .addCase(syncList.rejected, (state, action) => {
                state.loading = false;
                state.alertMessage = 'Unable to sync list';
                state.successMessage = undefined;
            })
            .addCase(downloadList.pending, (state, action) => {
                state.loading = true;
                state.alertMessage = undefined;
                state.successMessage = undefined;
                state.download = undefined;
            })
            .addCase(downloadList.fulfilled, (state, action) => {
                state.alertMessage = undefined;
                state.successMessage = undefined;
                state.loading = false;
                if (action.payload) {
                    state.download = action.payload;
                }
            })
            .addCase(downloadList.rejected, (state, action) => {
                state.loading = false;
                state.alertMessage = 'Unable to download this list';
                state.successMessage = undefined;
                state.download = undefined;
            })
            .addCase(parseList.pending, (state, action) => {
                state.loading = true;
                state.alertMessage = undefined;
                state.successMessage = undefined;
            })
            .addCase(parseList.fulfilled, (state, action) => {
                state.alertMessage = undefined;
                state.successMessage = 'Successfully parse list';
                state.loading = false;
                if (action.payload) {
                    state.adminLists = action.payload;
                }
            })
            .addCase(parseList.rejected, (state, action) => {
                state.loading = false;
                state.alertMessage = 'Unable to parse list';
                state.successMessage = undefined;
            })
            .addCase(matchList.pending, (state, action) => {
                state.loading = true;
                state.alertMessage = undefined;
                state.successMessage = undefined;
            })
            .addCase(matchList.fulfilled, (state, action) => {
                state.alertMessage = undefined;
                state.successMessage = 'Successfully matched list';
                state.loading = false;
            })
            .addCase(matchList.rejected, (state, action) => {
                state.loading = false;
                state.alertMessage = 'Unable to match list';
                state.successMessage = undefined;
            })
            .addCase(reSyncList.pending, (state, action) => {
                state.loading = true;
                state.alertMessage = undefined;
                state.successMessage = undefined;
            })
            .addCase(reSyncList.fulfilled, (state, action) => {
                state.alertMessage = undefined;
                state.successMessage = 'Successfully re-sync list';
                state.loading = false;
                if (action.payload) {
                    state.adminLists = action.payload;
                }
            })
            .addCase(reSyncList.rejected, (state, action) => {
                state.loading = false;
                state.alertMessage = 'Unable to re-sync list';
                state.successMessage = undefined;
            });
    }
});

export const { clearState } = adminListSlice.actions;
export default adminListSlice.reducer;
